import type {RutaProd} from '../../../../runtime/rutas';
export default {
  "ruta": "/sistema/store/settings",
  "alias": [],
  "documento": "pos-store",
  "acceso": "sesion",
  "filas": [
    "112"
  ],
  "cita": "Areas/POS_Store/Controllers/SettingsController.cs"
} satisfies RutaProd;
